<template>
  <page-header title="Перевозка медицинских изделий"/>
  <div class="public-container public-container-mobile shipping-types">
    <div id="about" class="shipping-types-banner-wrapper">
      <div class="shipping-types-banner mb-30">
        <public-card-info img-url="/images/pages/shipping-type/medical-mrt.png">
          <div class="shipping-types-card-text">
            {{ content.blocks?.about.cardText }}
          </div>
        </public-card-info>
        <public-card-attention :text="content.blocks?.insurance.attentionTitle" class="mt-30">
          <template #append>
            <div class="mt-20" v-html="content.blocks?.insurance.attentionText"/>
          </template>
        </public-card-attention>
      </div>

      <div>
        <p>{{ description }}</p>
      </div>
    </div>

    <div class="shipping-types-block">
      <h2 class="vz-text-align-left">{{ content.blocks?.about.title }}</h2>
      <p v-html="content.blocks?.about.text"/>

      <div class="public-text-line mt-35" v-html="content.blocks?.about.attention"/>
    </div>

    <div id="insurance" class="shipping-types-block">
      <h2 class="vz-text-align-left">{{ content.blocks?.insurance.title }}</h2>
      <p>{{ content.blocks?.insurance.description }}</p>
    </div>

    <div id="order" class="shipping-types-block">
      <h2 class="vz-text-align-left">{{ content.blocks?.order.title }}</h2>
      <div class="medical-grid mb-90">
        <public-info-grid-block v-for="(item, index) of items" :key="index" :item="item" rounded-style/>
      </div>
    </div>

    <shipping-types-buttons />
    
    <shipping-types-chain current="medical-devices" />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import PublicInfoGridBlock from "~/components/public/public-info-grid-block.vue"
import PublicCardAttention from "~/components/public/public-card-attention.vue"
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import {appleApp, googleApp} from '~/api/constant-urls'
import {getPageContent, replaceContentText} from '~/api/content';
import {storeToRefs} from 'pinia';
import {useCityStore} from '~/stores/city';

const {currentCity} = storeToRefs(useCityStore())

const content = {
  "title": null, "keywords": null, "description": null, "blocks": {
    "about": {
      "attention": "В разделе <a href=\"/wrapping\">«Упаковка»</a> представлены все виды используемых материалов с подробным объяснением и определением назначения их использования, а также стоимостью",
      "cardText": "Медицинские изделия и оборудование относятся к грузам, для перевозки которых необходимо использование жёсткой упаковки, согласно правилам перевозки, принятым в компании Vozovoz",
      "description": "Транспортная компания Vozovoz организовывает перевозки медицинских товаров и оборудования из %city.prepositional_name2% по всей территории России, Беларуси, Казахстана и Киргизии. Транспортировка медицинских изделий производится в строгом соответствии с правилами техники безопасности.",
      "text": "Для того, чтобы максимально обезопасить перевозимые грузы также можно самостоятельно упаковать отправления или воспользоваться услугами дополнительной упаковки из качественных материалов для всех типов грузов от компании. Сотрудники Vozovoz проведут консультацию по подбору наиболее подходящей упаковки для определённого груза на этапе формирования заявки на перевозку.",
      "title": "Правила упаковки медицинских изделий для транспортировки"
    },
    "insurance": {
      "attentionText": "Условия страхования и другая важная информация представлены в <a href=\"/insurance\" style=\"text-decoration: underline; color: white\">одноименном разделе сайта</a>",
      "attentionTitle": "Традиционное страхование применяется для грузов с объявленной стоимостью, а потоковое для обратных случаев",
      "description": "Медицинские изделия часто относятся к категории хрупких грузов, перевозка которых сопряжена с определёнными рисками. В Vozovoz доступны дополнительные услуги по традиционному и потоковому страхованию грузов, которые гарантируют материальное возмещение в случае повреждений отправления в ходе перевозки.",
      "title": "Страхование ценных грузов при транспортировке"
    },
    "order": {
      "lkText": "Личный кабинет - это удобный онлайн-сервис с круглосуточным доступом к полной информации о заказах, состоянию счетов и документообороту. При оформлении заказа действует скидка до 10%. <a href=\"/personal\">Зарегистрироваться</a> за несколько минут.",
      "lkTitle": "В личном кабинете",
      "mobileText": "В приложении Vozovoz можно оформить перевозку медицинского оборудования, рассчитать её стоимость и узнать примерные сроки доставки. В мобильном сервисе доступен полный спектр удобных способов оплаты заказов, в том числе по QR-коду. В приложении можно дополнительно отследить график перевозки. Доступно в <a href=\"%googleApp%\">Play Market</a> или <a href=\"%appleApp%\">App Store</a>.",
      "mobileTitle": "В мобильном приложении",
      "phoneText": "Сотрудники горячей линии Vozovoz помогут в оформлении заявки и объяснят все необходимые нюансы перевозки. Проконсультироваться по доставке или заказать звонок возможно по кнопке «помощь менеджера» в форме расчёта на сайте или по звонку на единую горячую линию",
      "phoneTitle": "По телефону горячей линии",
      "siteText": "В специальной <a href=\"/order/create\">форме расчёта</a> на официальном сайте можно узнать точную цену индивидуального заказа перевозки медицинского оборудования. Стоимость может измениться только в случае неправильно указанных габаритов или веса отправления, а также добавления или отказа от дополнительных услуг.",
      "siteTitle": "На сайте Vozovoz",
      "terminalText": "Для того чтобы узнать график работы и адрес филиала в ближайшем городе - введите его название в форму в <a href=\"/terminals\">соответствующем разделе</a> на официальном сайте компании.",
      "terminalTitle": "На одном из терминалов компании",
      "title": "Заказать перевозку медицинских изделий можно одним из нижеперечисленных способов:"
    }
  }, "rawContent": null
}

const description = computed(() => {
  return replaceContentText(content.blocks?.about.description, {city: currentCity.value})
})

const items = computed(() => [
  {
    icon: {
      url: '/svg/vz-phone-success-2.svg'
    },
    title: content.blocks?.order.mobileTitle,
    text: replaceContentText(content.blocks?.order.mobileText, {googleApp, appleApp}),
  },
  {
    icon: {
      url: '/svg/vz-monitor.svg'
    },
    title: content.blocks?.order.siteTitle,
    text: content.blocks?.order.siteText,
  },
  {
    icon: {
      url: '/svg/phone-in-talk.svg'
    },
    title: content.blocks?.order.phoneTitle,
    text: content.blocks?.order.phoneText,
  },
  {
    icon: {
      url: '/svg/package.svg'
    },
    title: content.blocks?.order.terminalTitle,
    text: content.blocks?.order.terminalText,
  },
  {
    icon: {
      url: '/svg/vz-person.svg'
    },
    title: content.blocks?.order.lkTitle,
    text: content.blocks?.order.lkText,
  },
])
</script>

<style lang="scss" scoped>
.medical-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  @media screen and (min-width: $pub-sm + 1) {
    $width-first-column: 400px;
    grid-template-columns: $width-first-column calc(47% - $width-first-column) repeat(3, 1fr);
    gap: 20px;
    div {
      &:nth-child(1) {
        grid-area: 1 / 1 / 3 / 2;
      }

      &:nth-child(2) {
        grid-area: 1 / 2 / 2 / 7;
      }

      &:nth-child(3) {
        grid-area: 2 / 2 / 3 / 7;
      }

      &:nth-child(4) {
        grid-area: 3 / 1 / 4 / 3;
      }

      &:nth-child(5) {
        grid-area: 3 / 3 / 4 / 7;
      }
    }
  }
}
</style>
